import React, { Component } from "react";
import { Box } from "@mui/material";
import { FormControl, FormGroup } from "@mui/material";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Spinner from "react-bootstrap/Spinner";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import settings from "../helpers/settings";
import axios from "axios";
import Cookies from "js-cookie";
import MoreOptions from "./moreOptions";
import UpdatePatient from "./updatePatient";
import codes from "./../helpers/countryCodes";
import Select from "react-select";
import Accordion from "react-bootstrap/Accordion";
import Typography from "@mui/material/Typography";

let { KayanURL } = settings;

class Patient extends Component {
  constructor(props) {
    super(props);
    let countryCodes = [];
    Object.keys(codes).map((key) => {
      countryCodes.push({ value: codes[key], label: key });
    });
    this.state = {
      patient: [],
      patientRegForm: true,
      countryCodes: countryCodes,
      searchInfo: {},
      searchFound: false,
      loading: false,
      offset: 0,
    };
  }
  componentDidMount = async () => {
    this.getAllPatient();
  };

  HandleInputTextChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    this.setState({ [name]: value });
  };
  HandleInputTextChangeCountry = (e) => {
    let value = e.value;
    this.setState({ ["country"]: value });
  };
  HandleInputSearchTextChangeCountry = (e) => {
    let value = e.value;
    this.setState({
      searchInfo: { ...this.state.searchInfo, ["country"]: value },
    });
  };
  // getAllPatient = async () => {
  //   this.setState({ loading: true });
  //   let response = await axios.put(
  //     KayanURL + "/test/patients/getPatient",

  //     {
  //       apiToken: Cookies.get("id"),
  //     }
  //   );
  //   if (response) {
  //     let { data } = response;
  //     if (data) {
  //       this.setState({ loading: false });
  //       let { success } = data;
  //       if (success) {
  //         this.setState({ allPatients: data.patient });
  //       } else {
  //         this.setState({
  //           success: false,
  //           error: data.error,
  //           allPatients: data.patient,
  //         });
  //       }
  //     }
  //   }
  // };

  // getAllPatient = async () => {
  //   this.setState({ loading: true });
  
  //   try {
  //     let response = await axios.put(
  //       KayanURL + "/test/patients/getPatient",
  //       {
  //         apiToken: Cookies.get("id"),
  //       }
  //     );
  
  //     if (response) {
  //       let { data } = response;
  //       if (data) {
  //         let { success, patient } = data;
  //         if (success) {
  //           let sortedPatients = patient.sort((a, b) => b.id - a.id); // يمكنك تعديل طريقة الترتيب حسب الحاجة
  
  //           let totalPatients = sortedPatients.length;
  
  //           let paginatedPatients = sortedPatients.slice(
  //             this.state.offset,
  //             this.state.offset + 20
  //           );
  
  //           this.setState({
  //             allPatients: sortedPatients, // حفظ جميع المرضى
  //             paginatedPatients: paginatedPatients, // حفظ المرضى المعروضين في الصفحة الحالية (20 فقط)
  //             totalPatients: totalPatients,
  //             loading: false,
  //             searchFound: false,
  //           });
  
  //           if (paginatedPatients.length === 0) {
  //             alert("You reached at the end");
  //           }
  //         } else {
  //           this.setState({
  //             success: false,
  //             error: data.error,
  //             allPatients: [],
  //             paginatedPatients: [],
  //             loading: false,
  //             searchFound: false,
  //           });
  //           alert("There is No Rows Found!");
  //         }
  //       }
  //     }
  //   } catch (error) {
  //     console.error("Error fetching patients:", error);
  //     this.setState({ loading: false, searchFound: false });
  //   }
  // };

  getAllPatient = async () => {
    this.setState({ loading: true });
  
    try {
      let response = await axios.put(
        KayanURL + "/test/patients/getPatient",
        {
          apiToken: Cookies.get("id"),
        }
      );
  
      if (response) {
        let { data } = response;
        if (data) {
          let { success, patient } = data;
          if (success) {
            let sortedPatients = patient.sort((a, b) => b.id - a.id); // يمكنك تعديل طريقة الترتيب حسب الحاجة
  
            let totalPatients = sortedPatients.length;
  
            let paginatedPatients = sortedPatients.slice(
              this.state.offset,
              this.state.offset + 20
            );
  
            this.setState({
            //   allPatients: sortedPatients, 
            //   paginatedPatients: paginatedPatients, 

              allPatients: paginatedPatients,
              totalPatients: totalPatients,
              loading: false,
              searchFound: false
            });
  
            if (paginatedPatients.length === 0) {
              alert("You reached at the end");
            }
          } else {
            this.setState({
              success: false,
              error: data.error,
              allPatients: [],
              loading: false,
              searchFound: false,
            });
            alert("There is No Rows Found!");
          }
        }
      }
    } catch (error) {
      console.error("Error fetching patients:", error);
      this.setState({ loading: false, searchFound: false});
    }
  };

 

  handleNext = () => {
    this.setState(
      (prevState) => ({ offset: prevState.offset + 20 }),
      () => this.getAllPatient()
    );
  };
  
  handlePrevious = () => {
    this.setState(
      (prevState) => ({ offset: Math.max(prevState.offset - 20, 0) }),
      () => this.getAllPatient()
    );
  };

  handleUpdatePatient = async (index) => {
    this.setState({
      patientupdate: true,
      patientRegForm: false,
    });
    let arrayOfpatientInfo = [];
    let { allPatients } = this.state;
    let selectedPatient = allPatients.filter((p) => {
      return p.id === index;
    });
    if (selectedPatient && selectedPatient.length > 0) {
      arrayOfpatientInfo.push({
        patientId: selectedPatient[0].id,
        firstName: selectedPatient[0].first_name,
        lastName: selectedPatient[0].last_name,
        identifier: selectedPatient[0].identifier,
        profileId: selectedPatient[0].profile_id,
        gender: selectedPatient[0].gender,
        birthDate: selectedPatient[0].birthdate,
        phone: selectedPatient[0].phone,
        identifierType: selectedPatient[0].identifier_type,
        country: selectedPatient[0].country,
      });
      this.setState({ arrayOfpatientInfo });
    }
  };
  handleDeletePatient = async (index) => {
    let deletePatient = await axios.put(
      KayanURL + "/test/patients/deletePatient",
      { patient_id: index, apiToken: Cookies.get("id") }
    );
    if (deletePatient) {
      let { data } = deletePatient;
      if (data) {
        if (data.success) {
          this.getAllPatient();
        } else {
          this.setState({ success: false, error: data.error });
        }
      }
    }
  };
  handlePatientRegistration = async (e) => {
    e.preventDefault();
    this.setState({
      requestSent: true,
      registrationResponse: false,
      error: "",
    });
    let patient = {
      first_name: this.state.firstName,
      last_name: this.state.lastName,
      identifier: this.state.identifier,
      profile_id: this.state.profileId,
      gender: this.state.gender,
      birthdate: this.state.birthdate,
      phone: this.state.phone,
      identifier_type: this.state.identifierType,
      country: this.state.country,
    };
    let response = await axios.post(
      KayanURL + "/test/patients/addPatient",

      {
        apiToken: Cookies.get("id"),
        patient: patient,
      }
    );

    if (response) {
      this.setState({
        requestSent: false,
        registrationResponse: true,
      });
      let { data } = response;
      if (data) {
        let { success, error } = data;
        if (success) {
          this.getAllPatient();
        } else {
          this.setState({ error });
          console.log(error);
        }
      }
    }
  };
  backToPatientScreenFromUpdatePatientScreen = (e) => {
    this.setState({
      patientupdate: false,
      patientRegForm: true,
    });
    this.getAllPatient();
  };
  HandleInputSearchRequestTextChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    let patientName,
      patientLastName = "";
    if (name === "name") {
      patientName = value.trim().split(" ");
      if (patientName.length > 1) {
        for (let i = 1; i < patientName.length; i++) {
          patientLastName += patientName[i] + " ";
        }
        this.setState({
          searchInfo: {
            ...this.state.searchInfo,
            first_name: patientName[0],
            last_name: patientLastName.trim(),
          },
          name: value,
        });
      } else {
        this.setState({
          searchInfo: {
            ...this.state.searchInfo,
            first_name: patientName[0],
            last_name: "",
          },
          name: value,
        });
      }
    } else {
      this.setState({
        searchInfo: { ...this.state.searchInfo, [name]: value },
        [name]: value,
      });
    }
  };
  handleSearchRequest = async () => {
    let { searchInfo, allPatients } = this.state;
    if (Object.keys(searchInfo).length === 0 || searchInfo === undefined) {
      this.setState({ searchErrMsg: "Please select a value to search" });
    }
    for (let key in searchInfo) {
      if (searchInfo.hasOwnProperty(key) && searchInfo[key] === "") {
        this.setState({ searchErrMsg: "Please select a value to search" });
      } else {
        this.setState({
          searchRequestSent: true,
          searchDone: false,
          searchErrMsg: "",
        });
        let selectedPatients = allPatients.filter((patient) => {
          for (const key in searchInfo) {
            const searchValue = searchInfo[key].toLowerCase();
            const patientValue = patient[key]?.toLowerCase() || "";

            if (!patientValue.includes(searchValue)) {
              return false;
            }
            return true;
          }
        });
        if (selectedPatients && selectedPatients.length > 0) {
          this.setState({ allPatients: selectedPatients });
          setTimeout(() => {
            this.setState({
              searchRequestSent: false,
              searchDone: true,
              searchFound: true,
            });
          }, 500);
        } else {
          this.setState({
            name: "",
            identifier: "",
            birthdate: "",
            gender: "",
            profile_id: "",
            identifierType: "",
          });
          this.setState({
            allPatients: allPatients,
            searchErrMsg: "No patient with this information...",
            searchFound: false,
          });
          setTimeout(() => {
            this.setState({
              searchRequestSent: false,
              searchDone: true,
            });
          }, 500);
        }
        this.setState({
          name: "",
          identifier: "",
          birthdate: "",
          gender: "",
          profile_id: "",
          identifierType: "",
        });

        console.log("Selected Patients:", selectedPatients);
      }
    }
  };

  // handleSearchRequest = async () => {
  //   let { searchInfo, allPatients } = this.state;
  
  //   // التحقق من وجود قيم للبحث
  //   if (Object.keys(searchInfo).length === 0 || searchInfo === undefined) {
  //     this.setState({ searchErrMsg: "Please select a value to search" });
  //     return; // إيقاف التنفيذ إذا لم يتم تحديد قيم للبحث
  //   }
  
  //   for (let key in searchInfo) {
  //     if (searchInfo.hasOwnProperty(key) && searchInfo[key] === "") {
  //       this.setState({ searchErrMsg: "Please select a value to search" });
  //       return; // إيقاف التنفيذ إذا كانت قيمة البحث فارغة
  //     }
  //   }
  
  //   this.setState({
  //     searchRequestSent: true,
  //     searchDone: false,
  //     searchErrMsg: "",
  //   });
  
  //   let selectedPatients = allPatients.filter((patient) => {
  //     for (const key in searchInfo) {
  //       const searchValue = searchInfo[key].toLowerCase();
  //       const patientValue = patient[key]?.toLowerCase() || "";
  
  //       if (!patientValue.includes(searchValue)) {
  //         return false;
  //       }
  //     }
  //     return true;
  //   });
  
  //   if (selectedPatients && selectedPatients.length > 0) {
  //     this.setState({
  //       paginatedPatients: selectedPatients.slice(0, 20), // عرض أول 20 نتيجة
  //       searchFound: true, // تعيين searchFound إلى true عند العثور على نتائج
  //     });
  //     setTimeout(() => {
  //       this.setState({
  //         searchRequestSent: false,
  //         searchDone: true,
  //       });
  //     }, 500);
  //   } else {
  //     this.setState({
  //       paginatedPatients: allPatients.slice(this.state.offset, this.state.offset + 20), // إعادة تعيين إلى المرضى المعروضين في الصفحة الحالية
  //       searchErrMsg: "No patient with this information...",
  //       searchFound: false, // تعيين searchFound إلى false عند عدم العثور على نتائج
  //     });
  //     setTimeout(() => {
  //       this.setState({
  //         searchRequestSent: false,
  //         searchDone: true,
  //       });
  //     }, 500);
  //   }
  
  //   // إعادة تعيين حقول البحث
  //   this.setState({
  //     name: "",
  //     identifier: "",
  //     birthdate: "",
  //     gender: "",
  //     profile_id: "",
  //     identifierType: "",
  //   });
  
  //   console.log("Selected Patients:", selectedPatients);
  // };
  render() {
    const { loading } = this.state;
    let { allPatients } = this.state;
    // let { paginatedPatients } = this.state;
    let PatientRows = [];
    if (allPatients && allPatients.length > 0) {
      PatientRows = allPatients.map((element, index) => {
        return (
      // if (paginatedPatients && paginatedPatients.length > 0) {
      //   PatientRows = paginatedPatients.map((element, index) => {
      //     return (
          <TableRow key={index}>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.profile_id}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.first_name} {element.last_name}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.identifier_type}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.identifier}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.country}{" "}
            </TableCell>

            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.gender}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.birthdate}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.phone}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              <MoreOptions
                index={element.id}
                handleDelete={() => this.handleDeletePatient(element.id)}
                handleUpdate={() => this.handleUpdatePatient(element.id)}
                optionFor="patient"
              />
            </TableCell>
          </TableRow>
        );
      });
    }
    return (
      <>
        <Box height={60} />
        <div
          style={{
            textAlign: "left",
            boxShadow: "1px solid grey",
            padding: "15px",
            boxShadow:
              "0px 2px 4px -1px rgba(0,0,0,0.3),0px 4px 5px 0px rgba(0,0,0,0.15),0px 1px 10px 0px rgba(0,0,0,0.11)",
            borderRadius: "10px",
          }}
        >
          <div>
            {this.state.patientRegForm ? (
              <>
                {/* search form */}
                <div style={{ width: "90%", margin: "auto", padding: "20px" }}>
                  <Accordion
                    defaultActiveKey="0"
                    style={{
                      margin: "auto",
                      paddingBottom: "0px",
                      width: "80%",
                    }}
                  >
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>
                        <span style={{ color: "grey" }}>Search Patient</span>
                      </Accordion.Header>
                      <Accordion.Body>
                        <Row>
                          <Col>
                            <Form.Group className="mb-3">
                              <Form.Label style={{ fontSize: "13px" }}>
                                Patient Name
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="name"
                                value={this.state.name ? this.state.name : ""}
                                required
                                onChange={
                                  this.HandleInputSearchRequestTextChange
                                }
                                placeholder="Enter Patient Name"
                              />
                            </Form.Group>
                            <Form.Group className="mb-3">
                              <Form.Label style={{ fontSize: "13px" }}>
                                Profile ID
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="profile_id"
                                value={
                                  this.state.profile_id
                                    ? this.state.profile_id
                                    : ""
                                }
                                onChange={
                                  this.HandleInputSearchRequestTextChange
                                }
                                placeholder="Enter Profile ID"
                              />
                            </Form.Group>
                            <Form.Group className="mb-3">
                              <Form.Label style={{ fontSize: "13px" }}>
                                {" "}
                                Identifier Type{" "}
                              </Form.Label>
                              <Form.Select
                                onChange={
                                  this.HandleInputSearchRequestTextChange
                                }
                                required
                                name="identifierType"
                              >
                                <option value="0">select...</option>
                                <option value="NI">National Identifier</option>
                                <option value="PPN">Passport Number</option>
                                <option value="BCT">Birth Certificate</option>
                                <option value="MR">Medical Record</option>
                                <option value="memberid">Member ID</option>
                              </Form.Select>
                            </Form.Group>
                          </Col>
                          <Col>
                            <Form.Group className="mb-3">
                              <Form.Label style={{ fontSize: "13px" }}>
                                Identifier
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="identifier"
                                value={
                                  this.state.identifier
                                    ? this.state.identifier
                                    : ""
                                }
                                onChange={
                                  this.HandleInputSearchRequestTextChange
                                }
                                placeholder="Enter Identifier"
                              />
                            </Form.Group>
                            <Form.Group className="mb-3">
                              <Form.Label style={{ fontSize: "13px" }}>
                                Country{" "}
                              </Form.Label>
                              <Select
                                className="mb-3"
                                onChange={
                                  this.HandleInputSearchTextChangeCountry
                                }
                                options={this.state.countryCodes}
                                isSearchable="true"
                                required
                              ></Select>
                            </Form.Group>
                            <div style={{ width: "100%" }}>
                              <Button
                                variant="contained"
                                style={{
                                  marginTop: "16%",
                                  backgroundColor: "rgb(97 110 120",
                                  marginRight: "10px",
                                  color: "white",
                                }}
                                onClick={(e) => this.handleSearchRequest(e)}
                              >
                                Search
                              </Button>
                              <Button
                                variant="contained"
                                style={{
                                  marginTop: "16%",
                                  backgroundColor: "rgb(97 110 120",
                                  marginRight: "10px",
                                  color: "white",
                                }}
                                onClick={this.getAllPatient}
                              >
                                Back
                              </Button>
                            </div>
                          </Col>

                          <Col>
                            <Form.Group className="mb-3">
                              <Form.Label style={{ fontSize: "13px" }}>
                                Gender
                              </Form.Label>
                              <Form.Select
                                onChange={
                                  this.HandleInputSearchRequestTextChange
                                }
                                value={
                                  this.state.gender ? this.state.gender : ""
                                }
                                name="gender"
                              >
                                <option value="">Select...</option>
                                <option value="male">Male</option>
                                <option value="female">Female</option>
                                <option value="other">Other</option>
                              </Form.Select>
                            </Form.Group>
                            <Form.Group className="mb-3">
                              <Form.Label style={{ fontSize: "13px" }}>
                                Birth Date
                              </Form.Label>
                              <Form.Control
                                type="date"
                                name="birthdate"
                                value={
                                  this.state.birthdate
                                    ? this.state.birthdate
                                    : ""
                                }
                                onChange={
                                  this.HandleInputSearchRequestTextChange
                                }
                                placeholder="Enter Birth Date"
                              />
                            </Form.Group>
                          </Col>

                          {this.state.searchErrMsg ? (
                            <>
                              <Typography
                                style={{ textAlign: "center", color: "red" }}
                              >
                                {this.state.searchErrMsg}
                              </Typography>
                            </>
                          ) : null}
                        </Row>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                  {this.state.searchRequestSent && !this.state.searchDone ? (
                    <div style={{ textAlign: "center", marginTop: "10px" }}>
                      <Spinner animation="border" variant="success" />
                    </div>
                  ) : this.state.searchDone && this.state.error ? (
                    <h5 style={{ color: "red", textAlign: "center" }}>
                      {this.state.error}
                    </h5>
                  ) : null}
                </div>
                <hr />
                {/* regiset form */}
                <div style={{ width: "95%", margin: "auto", padding: "20px" }}>
                  <FormControl style={{ width: "100%" }}>
                    <Container>
                      <Row>
                        <Col>
                          <Form.Group className="mb-3">
                            <Form.Label style={{ fontSize: "13px" }}>
                              Profile ID *
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="profileId"
                              onChange={this.HandleInputTextChange}
                              required
                              placeholder=" Enter Profile ID"
                            />
                          </Form.Group>
                          <Form.Group className="mb-3">
                            <Form.Label style={{ fontSize: "13px" }}>
                              First Name *
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="firstName"
                              required
                              onChange={this.HandleInputTextChange}
                              placeholder="Enter First Name"
                            />
                          </Form.Group>

                          <Form.Group className="mb-3">
                            <Form.Label style={{ fontSize: "13px" }}>
                              Birthdate *
                            </Form.Label>
                            <Form.Control
                              type="date"
                              name="birthdate"
                              onChange={this.HandleInputTextChange}
                              required
                            />
                          </Form.Group>
                        </Col>
                        <Col>
                          <Form.Group className="mb-3">
                            <Form.Label style={{ fontSize: "13px" }}>
                              Identifier Type *
                            </Form.Label>
                            <Form.Select
                              onChange={this.HandleInputTextChange}
                              required
                              name="identifierType"
                            >
                              <option value="0">select...</option>
                              <option value="NI">National Identifier</option>
                              <option value="PPN">Passport Number</option>
                              <option value="BCT">Birth Certificate</option>
                              <option value="MR">Medical Record</option>
                              <option value="memberid">Member ID</option>
                            </Form.Select>
                          </Form.Group>

                          <Form.Group className="mb-3">
                            <Form.Label style={{ fontSize: "13px" }}>
                              Last Name *
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="lastName"
                              onChange={this.HandleInputTextChange}
                              required
                              placeholder="Enter Last Name"
                            />
                          </Form.Group>
                        </Col>
                        <Col>
                          <Form.Group className="mb-3">
                            <Form.Label style={{ fontSize: "13px" }}>
                              Identifier *
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="identifier"
                              onChange={this.HandleInputTextChange}
                              required
                              placeholder="Enter Identifier Number"
                            />
                          </Form.Group>

                          <Form.Group
                            className="mb-3"
                            controlId="formBasicEmail"
                          >
                            <Form.Label style={{ fontSize: "13px" }}>
                              Phone{" "}
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="phone"
                              required
                              onChange={this.HandleInputTextChange}
                              placeholder="Enter Phone"
                            />
                          </Form.Group>
                        </Col>
                        <Col>
                          <Form.Group className="mb-3">
                            <Form.Label style={{ fontSize: "13px" }}>
                              Country *
                            </Form.Label>
                            <Select
                              className="mb-3"
                              onChange={this.HandleInputTextChangeCountry}
                              options={this.state.countryCodes}
                              isSearchable="true"
                              required
                            ></Select>
                          </Form.Group>
                          <Form.Group className="mb-3">
                            <Form.Label style={{ fontSize: "13px" }}>
                              Gender *
                            </Form.Label>
                            <Form.Select
                              onChange={this.HandleInputTextChange}
                              required
                              name="gender"
                            >
                              <option value="0">select...</option>
                              <option value="female">Female</option>
                              <option value="male">Male</option>
                            </Form.Select>
                          </Form.Group>
                        </Col>
                      </Row>
                      <div>
                        <Button
                          variant="primary"
                          type="submit"
                          onClick={(e) => this.handlePatientRegistration(e)}
                          style={{
                            width: "15%",
                            marginTop: "32px",
                            backgroundColor: "rgb(78 75 75)",
                            border: "1px solid rgb(78 75 75)",
                          }}
                        >
                          Register
                        </Button>
                      </div>
                    </Container>
                  </FormControl>
                </div>
                {this.state.requestSent && !this.state.registrationResponse ? (
                  <div style={{ textAlign: "center", marginTop: "10px" }}>
                    <Spinner animation="border" variant="success" />
                  </div>
                ) : this.state.registrationResponse && this.state.error ? (
                  <h5 style={{ color: "red", textAlign: "center" }}>
                    {this.state.error}
                  </h5>
                ) : null}
                {loading ? (
                  <div style={{ textAlign: "center", marginTop: "30px" }}>
                    <Spinner animation="border" variant="success" />
                  </div>
                ) : (
                  <>
                    {allPatients && allPatients.length > 0 ? (
                      <>
                        <hr />

                        <TableContainer
                          component={Paper}
                          style={{
                            margin: "auto",
                            marginTop: "30px",
                            width: "100%",
                          }}
                        >
                          <Table aria-label="simple table">
                            <TableHead style={{ backgroundColor: "#fafafa" }}>
                              <TableRow style={{ textAlign: "center" }}>
                                <TableCell align="center">Profile ID</TableCell>
                                <TableCell align="center">Name</TableCell>
                                <TableCell align="center">
                                  Identifier Type
                                </TableCell>
                                <TableCell align="center">Identifier</TableCell>
                                <TableCell align="center">Country</TableCell>
                                <TableCell align="center">Gender</TableCell>
                                <TableCell align="center">Birth Date</TableCell>
                                <TableCell align="center">Phone</TableCell>
                                <TableCell align="center">Action</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>{PatientRows}</TableBody>
                          </Table>
                        </TableContainer>
                        <Button variant="contained"
                               style={{
                                 width: "10%",
                                 backgroundColor: "rgb(97 110 120",
                                 marginTop: "10px",
                                 color: "white",
                                 marginRight: "10px",
                                   }}
                                 onClick={this.handlePrevious}
                                 disabled={this.state.loading || this.state.offset === 0}
                                 >
                                  Previous
                                </Button>
                             <Button variant="contained"
                              style={{
                              width: "10%",
                              backgroundColor: "rgb(97 110 120",
                              marginTop: "10px",
                              color: "white",
                             }}
                           onClick={this.handleNext}
                          disabled={this.state.loading || this.state.offset + 20 >= this.state.totalPatients}
                          >
                         Next
                      </Button>
                      </>
                    ) : (
                      <>
                        <h5 style={{ color: "red", textAlign: "center" }}>
                          There is no patient!
                        </h5>
                      </>
                    )}
                    {this.state.searchFound ? (
                <>
                  <div style={{ width: "100%" }}>
                    <Button
                      variant="contained"
                      style={{
                        width: "10%",
                        backgroundColor: "rgb(97 110 120)",
                        marginTop: "10px",
                        color: "white",
                      }}
                      onClick={(e) => this.getAllPatient(e)} 
                    >
                      Clear Filter
                    </Button>
                  </div>
                </>
                 ) : null}
                    
                  </>
                )}
              </>
            ) : null}

            {this.state.patientupdate ? (
              <UpdatePatient
                selectedPatient={this.state.arrayOfpatientInfo}
                backToPatientScreen={
                  this.backToPatientScreenFromUpdatePatientScreen
                }
              />
            ) : null}
          </div>
        </div>
      </>
    );
  }
}
export default Patient;
